import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const DisclaimerCard: React.FC = () => {
    return (
        <Card className="mt-4 bg-yellow-50 border border-yellow-200">
            <CardContent className="pt-4"> {/* Add padding top */}
                <p className="text-xs text-yellow-800">
                    <strong>Disclaimer:</strong> Information provided is for educational purposes only and does not constitute financial advice. Option trading involves significant risk. Always consult with a qualified financial advisor before making investment decisions.
                </p>
            </CardContent>
        </Card>
    );
};

export default DisclaimerCard;
